export default __webpack_public_path__ + "static/media/orderHistory.94a63135.svg";